const FilterPill = ({ label, active, onClick }) => (
    <button
        onClick={onClick}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-all whitespace-nowrap ${active
            ? 'bg-gray-800 text-white border-gray-800'
            : 'bg-white text-gray-600 border-gray-300 hover:border-gray-400'
            }`}
    >
        {label}
    </button>
);

export default FilterPill;
